module.exports = __webpack_public_path__ + "static/media/halfCircleLightGreen4.fc27bedb.svg";